import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppPage from './components/AppPage';

import {
    BrowserRouter as Router
  } from "react-router-dom";

ReactDOM.render(<Router><AppPage style={{ minHeight: '100%' }} /></Router>, document.getElementById('root'));

